import type { PopoverState } from "react-tiny-popover";

export function getPopoverViewportOffset({
  popoverRect,
  boundaryRect,
  boundaryInset
}: Pick<PopoverState, "popoverRect" | "boundaryRect" | "boundaryInset">) {
  const left = Math.max(
    boundaryRect.left + boundaryInset,
    Math.min(
      popoverRect.left,
      boundaryRect.right - boundaryInset - popoverRect.width
    )
  );
  const top = Math.max(
    boundaryRect.top + boundaryInset,
    Math.min(
      popoverRect.top,
      boundaryRect.bottom - boundaryInset - popoverRect.height
    )
  );

  return { left: left - popoverRect.left, top: top - popoverRect.top };
}
